import { render, staticRenderFns } from "./projectLink.vue?vue&type=template&id=93936eda&"
import script from "./projectLink.vue?vue&type=script&lang=js&"
export * from "./projectLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports